
 import * as React from 'react';
 import {createComponent, EventName} from '@lit/react';
 
 import {ObcFormItem as ObcFormItemElement} from '@oicl/openbridge-webcomponents/dist/components/form-item/form-item.js';
 import {ObcFormItemActionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/form-item/form-item.js';
 export type {ObcFormItemActionChangeEvent} from '@oicl/openbridge-webcomponents/dist/components/form-item/form-item.js';
 

 
 export const ObcFormItem = createComponent({
   react: React,
   tagName: 'obc-form-item',
   elementClass: ObcFormItemElement,
   events: {
     
     onActionChange: 'action-change' as EventName<ObcFormItemActionChangeEvent>,
   }
  });
 
 